import React, { useEffect, useRef, useId } from 'react';
import { useFocusTrap } from '../hooks/useFocusTrap';

function Modal({
	isOpen,
	title,
	children,
	onCancel,
	onConfirm,
	confirmText = 'Confirm',
	cancelText = 'Cancel',
	hideFooter = false
}) {
	const overlayRef = useRef(null);
	const dialogRef = useRef(null);
	const titleId = useId();
	const bodyId = useId();

	useFocusTrap(dialogRef, isOpen);

	useEffect(() => {
		if (!isOpen) return undefined;

		const handleKeyDown = (event) => {
			if (event.key === 'Escape') {
				event.preventDefault();
				if (onCancel) onCancel();
			}
		};

		document.addEventListener('keydown', handleKeyDown);
		return () => document.removeEventListener('keydown', handleKeyDown);
	}, [isOpen, onCancel]);

	if (!isOpen) return null;

	const handleOverlayMouseDown = (event) => {
		if (event.target === overlayRef.current && onCancel) {
			onCancel();
		}
	};

	return (
		<div
			className="modal-overlay"
			ref={overlayRef}
			onMouseDown={handleOverlayMouseDown}
		>
			<div
				className="modal-content"
				role="dialog"
				aria-modal="true"
				aria-labelledby={titleId}
				aria-describedby={bodyId}
				ref={dialogRef}
				tabIndex={-1}
			>
				<div className="modal-header">
					<h3 className="modal-title" id={titleId}>{title}</h3>
				</div>
				<div className="modal-body" id={bodyId}>
					{children}
				</div>
			{!hideFooter && (onCancel || onConfirm) ? (
				<div className="modal-footer">
					{onCancel ? (
						<button className="btn btn-outline" onClick={onCancel}>{cancelText}</button>
					) : null}
					{onConfirm ? (
						<button className="btn btn-orange" onClick={onConfirm}>{confirmText}</button>
					) : null}
				</div>
			) : null}
			</div>
		</div>
	);
}

export default Modal; 